import { render, staticRenderFns } from "./SellingPreferenceCard.vue?vue&type=template&id=55563df2&"
import script from "./SellingPreferenceCard.vue?vue&type=script&lang=js&"
export * from "./SellingPreferenceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports